import React from 'react';

export default React.memo(function Title({ className = '', children }) {
  return (
    <span className={`uppercase text-center text-black text-4xl md:text-6xl font-Staatliches whitespace-pre-line select-none ${className}`}>{children}</span>
  );
})
